import { combineReducers } from "redux";
import authReducer from "./authReducer";
import cartReducer from "./cartReducer";
import categoriesReducer from "./categoriesReducer";
import currenciesReducer from "./currenciesReducer";
import currencyReducer from "./currencyReducer";
import languageReducer from "./languageReducer";
import settingsReducer from "./settingsReducer";
import translationsReducer from "./translationsReducer";
import userReducer from "./userReducer";
// import governatesReducer from "./governatesReducer";

const rootReducer = combineReducers({
  settings: settingsReducer,
  lang: languageReducer,
  currencies: currenciesReducer,
  currency: currencyReducer,
  translations: translationsReducer,
  cart: cartReducer,
  auth: authReducer,
  user: userReducer,
  categories: categoriesReducer,
  // products: productsReducer,
  // countries: countriesReducer,
  // selectedProduct: popUpProductReducer,
});

export default rootReducer;
